import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-47effe7e")

_pushScopeId("data-v-47effe7e")
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Zenith Bank Accounts", -1)
const _hoisted_4 = { class: "mt-5 mb-5" }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = { class: "card-body p-5" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 1,
  class: "btn btn-sm btn-primary",
  type: "button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.zenithaccountsList.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentlySelectedAccount = $event)),
            class: "form-control form-select form-select-solid",
            "data-kt-select2": "true",
            "data-placeholder": "Select an option",
            "data-allow-clear": "true",
            "data-kt-initialized": "1",
            onChange: _cache[2] || (_cache[2] = ($event: any) => {_ctx.updateSelectedZenithAccount();})
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.zenithaccountsList, (item, index) => {
              return (_openBlock(), _createBlock("option", {
                key: index,
                value: item.accountno
              }, _toDisplayString(item.accountname) + " - " + _toDisplayString(item.accountno), 9, ["value"]))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.currentlySelectedAccount]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode("label", {
        class: "text-primary btn btn-link btn-sm mb-5",
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddAccountForm()))
      }, " Add Zenith Account "),
      (_ctx.isShowAddAccountForm)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newaccountno = $event)),
                    class: "form-control form-control-solid",
                    placeholder: "Account Number"
                  }, null, 512), [
                    [_vModelText, _ctx.newaccountno]
                  ])
                ])
              ]),
              (_ctx.isSaving == false)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-primary",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveNewZenithAccount()))
                  }, " Save Account "))
                : _createCommentVNode("", true),
              (_ctx.isSaving == true)
                ? (_openBlock(), _createBlock("button", _hoisted_9, " Saving... "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})